import { type Dispatch, type SetStateAction, useEffect } from 'react'

import { SlimButton, Tooltip } from 'components'
import type { SapModalTypes } from 'container/ManageOVDetails/components/SapModal'
import { getOvStatusOptionsToSap, type OvDataToSap } from 'container/ManageOVDetails/utils'
import type { SapOptionsToOvStatus } from 'store/OVContext/ovContextTypes'
import { useSelector } from 'store/store'

import * as S from './styles'

type CheckedOVsVerificationProps = {
  setSapModal: Dispatch<SetStateAction<SapModalTypes | undefined>>
  ovsSapData: SapOptionsToOvStatus
  setOvsSapData: Dispatch<SetStateAction<SapOptionsToOvStatus>>
}

const CheckedOVsVerification = ({
  setSapModal,
  ovsSapData,
  setOvsSapData,
}: CheckedOVsVerificationProps) => {
  const { checkedOvs } = useSelector((state) => state.salesOrder)

  useEffect(() => {
    if (checkedOvs.length) {
      const ovDataToSap: OvDataToSap[] = checkedOvs.map((ov) => ({
        changeDate: ov.DataAlteracao ?? '',
        number: ov.NumeroOrdemVenda,
        statusKey: ov.StatusOrdemVenda,
      }))
      setOvsSapData(getOvStatusOptionsToSap(ovDataToSap))
    }
  }, [checkedOvs])

  const renderReturnToSalesAreaButton = () => (
    <S.ButtonSap>
      <SlimButton
        content="Devolver"
        disabled={!ovsSapData.isValidToReturnToSalesArea}
        onClick={() => setSapModal('salesAreaModal')}
        variant="secondary"
      />
    </S.ButtonSap>
  )

  const renderReturnSapButton = () => (
    <S.ButtonSap>
      <SlimButton
        content="Retornar do SAP"
        disabled={!ovsSapData.isValidToReturnFromSap}
        onClick={() => setSapModal('returnModal')}
        variant="secondary"
      />
    </S.ButtonSap>
  )

  const renderSendSapButton = () => (
    <S.ButtonSap>
      <SlimButton
        content="Enviar ao SAP"
        disabled={!ovsSapData.isValidToSendToSap}
        onClick={() => setSapModal('sendModal')}
        variant="primary"
      />
    </S.ButtonSap>
  )

  return (
    <S.Wrapper>
      <S.MessageCheckedOVs>O que deseja fazer com os itens selecionados?</S.MessageCheckedOVs>
      <S.ButtonsSapWrapper>
        {ovsSapData.isValidToReturnToSalesArea ? (
          renderReturnToSalesAreaButton()
        ) : (
          <Tooltip title="Apenas os status 09, 10 e 15 permitem a ação de Devolver para área de vendas">
            {renderReturnToSalesAreaButton()}
          </Tooltip>
        )}

        {ovsSapData.isValidToReturnFromSap ? (
          renderReturnSapButton()
        ) : (
          <Tooltip title="Apenas os status 20, 21, 22 e 40 permitem a ação de Retornar do SAP">
            {renderReturnSapButton()}
          </Tooltip>
        )}

        {ovsSapData.isValidToSendToSap ? (
          renderSendSapButton()
        ) : (
          <Tooltip title="Apenas os status 00, 05 e 08 permitem a ação de Enviar ao SAP">
            {renderSendSapButton()}
          </Tooltip>
        )}
      </S.ButtonsSapWrapper>
    </S.Wrapper>
  )
}

export default CheckedOVsVerification
